<!--
  布局-导航栏
-->
<template>
	<div>
		<div class="nav-container">
			<div class="flex-col-center">
				<div class="logo-container">
					<img :src="logo" />
				</div>
				<div class="collapse-icon flex-all-center" @click="collapseMenu">
					<img src="../../assets/images/logo_btn_icon.png"
						:style="isCollapse ? 'transform: rotate(180deg);' : ''" />
				</div>
			</div>

			<div class="flex-col-center" style="margin-right: 40px">
				<div class="nav-header">
					<img :src="userInfo.avatar" />
					<div class="header-icon" v-if="messageData.count > 0">{{ messageData.count }}</div>
				</div>
				<el-dropdown @command="handleCommand">
					<div class="nav-name">
						<span>{{userInfo.nickname}}</span>
						<i class="el-icon-arrow-down"></i>
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="0">消息提醒</el-dropdown-item>
						<el-dropdown-item command="1">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>

			<el-drawer :visible.sync="drawer" direction="rtl" append-to-body>
				<div slot="title" style="font-size: 16px">消息提醒</div>
				<div v-loading="message.loading" class="message-container">
					<div class="message-item flex-row-sb" v-for="(item, index) in messageData.list" :key="index"
						@click="viewMessage(item, item.msgType)">
						<div class="item-content flex-col-center">
							<div class="content-val">
								<div class="mes-title">{{ item.title }}</div>
								<div style="line-height: normal;font-size: 12px;" v-if="item.msgType == 'text'">
									{{ item.message }}
								</div>
								<div v-else class="val-text" style="font-size: 12px">
									{{ item.message }}
								</div>
							</div>
						</div>
						<div class="item-date">
							<div>{{ item.time }}</div>
							<div class="yidu-icon" v-if="item.isRead == 1">
								<img src="@/assets/images/home_icon_yidu.png" />
							</div>
						</div>
					</div>
					<el-pagination background layout="prev, pager, next" hide-on-single-page :page-size="8"
						:current-page.sync="message.page" :total="messageData .total" @current-change="getMessageList"
						class="box-paging">
					</el-pagination>
					<div class="no-data" v-if="!message.loading && messageData.list.length == 0">暂无消息</div>
				</div>
			</el-drawer>
		</div>
		<service-extension ref="serviceExtension"></service-extension>
	</div>
</template>

<script>
	import ServiceExtension from '@/components/Home/ServiceExtension.vue'
	export default {
		components: {
			ServiceExtension
		},
		data() {
			return {
				logo: '',
				drawer: false,
				message: {
					page: 1,
					loading: false
				}
			}
		},
		computed: {
			isCollapse() {
				return this.$store.state.app.isCollapse
			},
			userInfo() {
				return this.$store.state.user.userInfo || {}
			},
			// 消息列表
			messageData() {
				const {
					messageList,
					messageTotal,
					msgUnReadCount
				} = this.$store.state
				return {
					list: messageList,
					total: messageTotal,
					count: msgUnReadCount
				}
			}
		},
		watch: {},
		mounted() {
			this.getLogo()
			this.getMessageList()
			this.isExpiration()
			this.$store.commit('getMessageUnReadCount')
		},
		methods: {
			getLogo() {
				this.$api.system.logoInfo().then(({
					data
				}) => {
					if (data.code == 200) {
						this.logo = data.data.url
					}
				})
			},

			// 是否显示延期服务弹窗
			isExpiration() {
				let endDay = this.$store.state.user.serviceExtension.endDay; // 服务结束时间
				let status = this.$store.state.user.serviceExtension.status; // 是否已经申请延期
				if (endDay && (!status || status == '0')) {
					// 服务到期提醒
					let text = endDay == '0' ? `今天到期` : `还剩【${endDay}天】`;
					this.$confirm(
							Number(endDay) < 0 ? '尊敬的用户，您的西联系统运维服务【已到期】，为保障您持续享有西联服务，请您联系028-62997265，给您带来不便，敬请谅解。（注：出现本提示不会影响西联软件系统的使用，但您将无法获得西联运维服务的支持，感谢您对西联软件的支持！）' : `尊敬的用户，您的西联系统运维服务${text}，为给您提供持续的西联服务，请您协助我们完成服务续费工作，咨询电话：028-62997265，感谢您对西联软件的支持！`,
							'提示', {
								confirmButtonText: '申请服务延期',
								cancelButtonText: `${status=='0'?'延期申请中':'知道了'}`,
								showConfirmButton: status == '0' ? false : true,
								type: 'warning',
								closeOnClickModal: false
							})
						.then(() => {
							this.$refs.serviceExtension.open()
						})
						.catch(() => {

						})
					let serviceExtension = {
						endDay: '', //服务结束时间
						status: '', //是否已经申请延期
						applyExpirationTime: '' //服务延期至日期
					}
					this.$store.commit('user/setServiceExtension', serviceExtension)
				}
			},

			// 收起 展开
			collapseMenu() {
				this.$store.commit('app/setIsCollapse', !this.isCollapse)
			},

			// 获取消息列表
			async getMessageList() {
				this.message.loading = true
				try {
					await this.$store.dispatch('getMessageList', this.message.page)
				} finally {
					this.message.loading = false
				}
			},

			// 查看消息详情
			async viewMessage(data, type) {
				// 未读设置已读
				if (data.isRead == 0) {
					const res = await this.$api.home.messageRead(data.messageId)
					if (res.data.code === 200) {
						this.$store.commit('getMessageUnReadCount')
						this.getMessageList()
					}
				}
				if(type == "text"){ // 服务到期通知消息
					return;
				}
				this.drawer = false
				this.$router.push({
					path: '/workOrderDetail',
					query: {
						id: data.sheetId,
						focus: data.isAttention || undefined
					}
				})
			},

			//  下拉菜单
			async handleCommand(index) {
				switch (index) {
					case '0':
						this.drawer = true
						break
					case '1':
						await this.$store.dispatch('user/resetAuth')
						this.$router.push({
							path: '/login'
						})
						break
					default:
						break
				}
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import '~@/assets/styles/layout';

	.collapse-icon {
		width: 70px;
		height: 70px;
		cursor: pointer;
		transition: all 0.3s;

		&:hover {
			background-color: rgb(249, 249, 249);
		}

		img {
			width: 25px;
			height: 25px;
			object-fit: contain;
		}
	}

	.nav-header {
		width: 38px;
		height: 38px;
		border-radius: 50%;
		margin-right: 14px;
		position: relative;

		img {
			width: 100%;
			height: 100%;
			border-radius: 50%;
			object-fit: cover;
		}

		.header-icon {
			position: absolute;
			top: -5px;
			right: -5px;
			width: 20px;
			height: 20px;
			text-align: center;
			line-height: 20px;
			border-radius: 50%;
			background: #f56c6c;
			font-size: 12px;
			color: #fff;
		}
	}

	.nav-name {
		font-size: 14px;
		color: #777777;
		cursor: pointer;

		span {
			margin-right: 10px;
		}
	}

	.message-container {
		overflow: auto;
		overflow-x: hidden;
		height: 100%;

		&::-webkit-scrollbar {
			width: 4px;
		}

		&::-webkit-scrollbar-thumb {
			border-radius: 10px;
			background: rgba(0, 0, 0, 0.2);
		}

		&::-webkit-scrollbar-track {
			border-radius: 0;
			background: rgba(0, 0, 0, 0.1);
		}
	}

	.message-item {
		padding: 20px;
		box-sizing: border-box;
		border-radius: 4px;
		border-bottom: 1px solid #e9effd;
		transition: all 0.2s;
		font-size: 16px;
		cursor: pointer;

		&:hover {
			background: #f2f6ff;
			border-color: #e9effd;
		}

		&:last-child {
			border: none;
		}

		.item-content {
			flex: 1;
			height: 50px;
			margin-right: 20px;
			min-width: 0;

			.content-val {
				flex: 1;
				min-width: 0;
				height: 100%;
				padding: 5px 0;
				box-sizing: border-box;
				font-size: 14px;
				color: #40424f;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.val-text {
					width: 100%;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}

				.mes-title {
					font-weight: bold;
				}
			}
		}

		.item-date {
			font-size: 14px;
			color: #40424f;
			opacity: 0.5;

			.yidu-icon {
				width: 100%;
				height: 100%;
				margin-top: 13px;
				display: flex;
				justify-content: flex-end;

				img {
					width: 100%;
					height: 100%;
					width: 20px;
					height: 20px;
				}
			}
		}
	}

	.no-data {
		color: #999;
		text-align: center;
		font-size: 16px;
	}
</style>
